import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "url-polyfill";

import Embed from "@sopranodesign/pulse-embed-boost";

Embed.render();
